import { Link } from '@do/walrus';
import React, { FC } from 'react';

interface LearnMoreItemProps {
  url: string;
  title: string;
  description?: string;
}

const LearnMoreItem: FC<LearnMoreItemProps> = ({ url, title, description }) => (
  <div className="do-u-mb--medium">
    <Link type="external" to={url} target="_blank" rel="noopener noreferrer">
      {title}
    </Link>
    {!!description && <p>{description}</p>}
  </div>
);

export default LearnMoreItem;
